import ExpandableText from 'lib/components/expandable-text/expandable-text'

import { LoadingScreen } from 'components/pages/requests/empty-screens'
import { Project } from 'interfaces/project'
import IconButton from 'lib/components/buttons/icon-button'
import { Drawer } from 'lib/components/drawer/drawer'
import Tooltip from 'lib/components/tooltip/tooltip'
import { displayDate } from 'lib/util/date'
import { ArrowRightToLineIcon, FoldersIcon, NotepadTextIcon } from 'lucide-react'
import ProjectDeliverablesTable from '../project-deliverables-table'
import { Divider } from './project-drawer'
import ProjectPartnerContent from './project-partner-content'

interface ProjectReadOnlyContentProps {
  project: Project
  setOpen: (open: boolean) => void
  isLoading: boolean
}

/**
 * @deprecated this has been migrated to the web app and any changes should be made in both the web app and here
 */
export default function ProjectReadOnlyContent({ project, setOpen, isLoading }: ProjectReadOnlyContentProps) {
  return (
    <>
      <Drawer.Header setOpen={setOpen} showCloseButton={false} className="tw-static">
        <div className="tw-flex tw-w-full tw-items-center tw-gap-4">
          <IconButton size="xs" color="transparent" onClick={() => setOpen(false)} className="tw-mr-2">
            <ArrowRightToLineIcon className="tw-text-neutral-700" />
          </IconButton>
          <FoldersIcon className="lu-xl tw-text-neutral-700" />
          {!isLoading ? (
            <div className="tw-flex tw-flex-col tw-justify-center tw-gap-2 tw-overflow-hidden">
              <div className="tw-flex tw-items-center tw-gap-2">
                <Tooltip content={project?.name}>
                  <h3 className="tw-m-0 tw-truncate tw-p-0">{project?.name}</h3>
                </Tooltip>
              </div>
              <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-text-neutral-500">
                <div>Last updated on {displayDate(project?.updatedAt)}</div>
                {project?.projectTemplate?.partner && (
                  <>
                    <Divider />
                    <ProjectPartnerContent partner={project?.projectTemplate?.partner} />
                  </>
                )}
              </div>
            </div>
          ) : (
            <div className="tw-flex tw-flex-col tw-justify-center tw-gap-2">
              <div>Loading...</div>
            </div>
          )}
        </div>
      </Drawer.Header>
      <Drawer.Body className="tw-overflow-y-auto">
        {!isLoading ? (
          <>
            <div className="tw-mb-4">
              <h5 className="tw-flex tw-items-center tw-gap-1">
                <NotepadTextIcon className="lu-md" />
                <span>Description</span>
              </h5>
              <ExpandableText text={project?.description ?? 'No description'} />
            </div>
            <ProjectDeliverablesTable projectId={project?.id} readOnly />
          </>
        ) : (
          <LoadingScreen />
        )}
      </Drawer.Body>
    </>
  )
}
